import request from "./request";
export const http = {
  //厂商列表
  GRList(params) {
    return request({
      method: "POST",
      url: "/platform/pc/order/GR/list",
      data: params,
    });
  },
  //导表
  GRExcel(params) {
    return request({
      method: "POST",
      url: "/platform/pc/order/GR/excel",
      data: params,
      responseType: "blob",
    });
  },
  // 厂商下拉列表
  downListManufacturer(params) {
    return request({
      method: "GET",
      url: "/platform/pc/manufacturer/down/downListManufacturer",
      data: params,
    });
  },
  // 渠道下拉列表
  channelList(params) {
    return request({
      method: "GET",
      url: "/platform/pc/manufacturer/down/channelList",
      params,
    });
  },
};
